import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { GET_USERS } from "./apiRoutes";

/** Owner Master "Add Owner": POST /users/owners (generated User ID / Login ID, optional email). */
const useCreateOwnerMutation = (queryParams?: UseMutationOptions<any, Error, { data: any }, unknown>) =>
  useMutation({
    mutationFn: async ({ data }: { data: any }) => await axiosAuth.post(`${GET_USERS}/owners`, data),
    ...queryParams,
  });

export default useCreateOwnerMutation;
